import api from "@/api.js";


export default {
  namespaced: true,
  state: {
    list: [],
    listloading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },

  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("sources/units");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllBySourcesID({ commit }, sources_id) {
      commit("setListLoading", true);
      let list = await api.get("sources/units/bySourcesID", { params: { id: sources_id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("sources/units", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySourcesID", payload.sources_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`sources/units`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllBySourcesID", payload.sources_id);
      return returnData;
    }
  },
  getters: {
    list: (state) => state.list
  }
}
